export const overrideParagraphSpacing = {
  '&:not(:last-child)': { marginBlockEnd: '$none' },
};
